export default __webpack_public_path__ + "static/cube-2c9eb801f528c76aa2fa3986db33f9d2.svg";